<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-card>
      <v-card-title class="text-h5"> Reset Password </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="resetPassword">
          <label class="text-xs text-primary text-typo font-weight-bolder ms-1"
            >Email</label
          >
          <v-text-field
            v-model="email"
            type="email"
            hide-details
            required
            outlined
            light
            height="40"
            class="
              font-size-input
              border border-radius-md
              placeholder-lighter
              text-color-light
            "
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn dark color="secondary" text @click="dialog = false">
          Cancel
        </v-btn>
        <v-btn dark color="secondary" @click="resetPassword" :loading="loading">
          Send Reset Link
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import fb from "../../../../plugins/firebase";
const auth = fb.auth
import { sendPasswordResetEmail, ActionCodeSettings } from "firebase/auth";
const actionCodeSettings = {
  url: 'https://www.example.com/reset-password?mode=resetPassword&oobCode=${oobCode}&apiKey=${apiKey}',
  handleCodeInApp: false,
};
export default {
  name: "ResetPassword",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      email: "",
      loading: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
        if (!value) {
          this.email = "";
          this.loading = false;
        }
      },
    },
  },
  methods: {
    async resetPassword() {
      if (!this.email) {
        alert("Please enter your email address");
        return;
      }
      
      this.loading = true;
      try {
        // Get the current URL and construct the reset password URL
        const baseUrl = window.location.origin;
        const actionCodeSettings = {
          url: `${baseUrl}/reset-password-confirm`,
          handleCodeInApp: false
        };

        await sendPasswordResetEmail(auth, this.email, actionCodeSettings);
        alert("Password reset email sent. Please check your inbox and follow the link to reset your password.");
        this.dialog = false;
      } catch (error) {
        console.error("Error resetting password:", error);
        alert(error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
